import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { Button, Form, Modal } from "react-bootstrap";
import { _delete, _get } from "../../utils/APIClient";
import { ConfirmationAlert, getOnlyToken } from "../../utils/commonFunctions";
import axios from "axios";
import { set } from "react-hook-form";
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";
import PageHeader from '../PageHeader';

import Cookies from 'js-cookie';

export default function WorkFlowList() {
    const [search, setSearch] = useState("");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()
    const [workData, setWorkdata] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);

    const token = getOnlyToken();

    useEffect(() => {
        getWorkFlow()
    }, [])

    const handlePageChange = (page) => {
        getWorkFlow(page, perPage);
    };

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        getWorkFlow(1, newPerPage);
    };

    const getWorkFlow = async (pageNum = 1, pageSize = 10) => {
        try {
            setLoading(true)

            const config = { headers: { Authorization: `Bearer ${token}` } };
            const res = await axios.get(`/ivr/workflow-config/?pagenumber=${pageNum}&perpage=${pageSize}`, config);
            const pagination = res.data.pagination || {};

            if (res.status === 200) {
                setWorkdata(res.data.data || res.data);
                setCurrentPage(pagination.current_page || pageNum);
                setPerPage(pagination.per_page || pageSize);
                setTotalCount(pagination.total_count || 0);
            }

        } catch (error) {
            setErrorMessage(error.response?.data?.message || "Failed to delete workflow");
            setShowErrorModal(true);
        } finally {
            setLoading(false)

        }
    }


    const handleTogglePublish = async (workflow, event) => {
        if (event) {
            event.stopPropagation();
        }

        const newPublish = !workflow.publish_status;

        try {
            const config = { headers: { Authorization: `Bearer ${token}` } };
            await axios.put(`/ivr/workflow-config/${workflow.id}/`, {
                publish_status: newPublish
            }, config);

            await getWorkFlow(currentPage, perPage);
        } catch (error) {
            setErrorMessage(error.response?.data?.message || "Failed to update publish status");
            setShowErrorModal(true);
        }
    };

    const columns = [
        {
            name: "S.No",
            width: "100px",
            selector: (row, index) => index + 1,
            sortable: true,
        },
        {
            name: "Work Flow Names",
            selector: (row) => row.name,
            sortable: true,
            center: true
        },
        {
            name: "Description",
            selector: (row) => row.description,
        },
        // {
        //   name:'Assign Phone',
        //   selector:(row)=>row.assign_phone,
        //   cell:(row)=>(
        //     <div className="d-flex gap-2">
        //       <div className="d-flex align-items-center gap-2">
        //         <i className="bi bi-telephone-fill"></i>
        //         <p className="mb-0">{row.assign_phone}</p>
        //       </div>
        //     </div>
        //   )
        // },
        {
            name: 'Publish',
            width: '130px',
            cell: row => (
                <div className="form-check form-switch" onClick={(e) => e.stopPropagation()}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={!!row.publish_status}
                        onChange={(e) => handleTogglePublish(row, e)}
                        style={{ cursor: 'pointer', width: '2.5rem', height: '1.25rem' }}
                    />
                    
                </div>
            ),
        },
        {
            name: "Actions",
            width: "150px",
            cell: (row) => (
                <div className="d-flex gap-2 justify-content-center">
                    {/* Edit */}
                    {customeredit ? <button
                        className="btn btn-sm d-flex align-items-center justify-content-center rounded-circle    "
                        title="Edit"
                        onClick={() =>
                            navigate(`/configurations/workflowcreate/?workflowid=${row.id}`)}
                        style={{ width: 34, height: 34, backgroundColor: "#014670", color: "#fff" }}
                    >
                        <i className="bi bi-pencil"></i>
                    </button> : ""}

                    {/* Delete */}
                    {customerdelete ? <button
                        className="btn btn-sm d-flex align-items-center justify-content-center rounded-circle     "
                        title="Delete"
                        onClick={() => handleDeleteClick(row)}
                        style={{ width: 34, height: 34, backgroundColor: "#da3333ff", color: "#fff" }}
                    >
                        <i className="bi bi-trash"></i>
                    </button> : ""}
                </div>
            ),
        }

    ];



    const customStyles = {
        table: {
            style: {
                backgroundColor: "#ffffff",
                borderRadius: "8px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#064c77",
                borderBottom: "1px solid #dee2e6",
                minHeight: "52px",
            },
        },
        headCells: {
            style: {
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                textTransform: "uppercase",
            },
        },
        rows: {
            style: {
                minHeight: "56px",
                backgroundColor: "#ffffff",
                "&:hover": {
                    backgroundColor: "#f8f9fa",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                },
            },
        },
        cells: {
            style: {
                fontSize: "14px",
                color: "#495057",
                borderBottom: "1px solid #f1f3f5",
            },
        },
        pagination: {
            style: {
                borderTop: "1px solid #dee2e6",
                padding: "8px",
            },
        },
        noData: {
            style: {
                backgroundColor: "#ffffff",
                color: "#6c757d",
                padding: "24px",
            },
        },
    };

    const handleSearch = () => {
        console.log('clicked')
    }

    const handleDeleteClick = (workflow) => {
        ConfirmationAlert(
            `You won't be able to revert this workflow "${workflow.name}"!`,
            'Yes, delete it!',
            () => handleDeleteConfirm(workflow.id)
        );
    }

    const handleDeleteConfirm = async (workflowId) => {
        setLoading(true);
        try {
            await _delete(`api/admin/workflow_config/${workflowId}/delete/`);

            await getWorkFlow(currentPage, perPage);

            setShowSuccessModal(true);

        } catch (error) {
            setErrorMessage(error.response?.data?.message || "Failed to delete workflow");
            setShowErrorModal(true);
        } finally {
            setLoading(false);
        }
    }

    const mainHeading = "WorkFlows";
    const heading = `Digital Employee / ${mainHeading}`;
    const access_privileges = JSON.parse(Cookies.get("modulepermissions"))
    const [customerlist, setcustomerlist] = useState(false)
    const [customeradd, setcustomeradd] = useState(false)
    const [customeredit, setcustomeredit] = useState(false)
    const [customerdelete, setcustomerdelete] = useState(false)

    useEffect(() => {


        access_privileges.map((access, i) => {
            access.sub_module_info.map((subaccess, k) => {
                if (subaccess.name == "Workflow Configurations" && subaccess.permissions.indexOf(1) !== -1) {
                    setcustomerlist(true)
                }
                if (subaccess.name == "Workflow Configurations" && subaccess.permissions.indexOf(2) !== -1) {
                    setcustomeradd(true)
                }
                if (subaccess.name == "Workflow Configurations" && subaccess.permissions.indexOf(3) !== -1) {
                    setcustomeredit(true)
                }
                if (subaccess.name == "Workflow Configurations" && subaccess.permissions.indexOf(4) !== -1) {
                    setcustomerdelete(true)
                }

            })


        })
    }, [])
    return (
        <div id="layout-wrapper">
            <Header />
            <Sidebar />

            <div className="page-content">

                <div className="main-content" style={{ backgroundColor: "#ededed" }}>
                    <PageHeader mainHeading={mainHeading} heading={heading} />
                    <div className="container-fluid py-2" >
                        <div className="d-flex align-items-center justify-content-end mb-2">

                            <div className="d-flex gap-2  justify-content-end  align-items-center mb-3">
                                <div className="row ">
                                    <div className="col-md-12 d-flex justify-content-end">
                                        <div
                                            style={{ position: "relative", maxWidth: "250px", width: "100%" }}
                                        >
                                            <i
                                                className="bi bi-search"
                                                style={{
                                                    position: "absolute",
                                                    left: "10px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    color: "#6c757d",
                                                    fontSize: "14px",
                                                }}
                                            ></i>

                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Search Workflow..."
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                style={{ paddingLeft: "32px", borderRadius: '7px' }}
                                            />
                                        </div>

                                        <Button
                                            onClick={handleSearch} className="btn-sm mx-2">Search</Button>
                                    </div>


                                </div>
                                {customeradd ? <Button
                                    onClick={() =>
                                        navigate('/configurations/workflowcreate')
                                    }

                                    className="btn  mx-2"
                                >
                                    <i className="bi bi-diagram-3"></i> &nbsp;

                                    Create WorkFlow
                                </Button> : ""}
                            </div>
                        </div>

                        {/* Table */}
                        <div className="card border-0 shadow-sm" style={{ backgroundColor: "#ffffff" }}>
                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-success" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <DataTable
                                    columns={columns}
                                    data={workData}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalCount}
                                    paginationDefaultPage={currentPage}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerPageChange}
                                    onChangePage={handlePageChange}
                                    paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                    customStyles={customStyles}
                                />
                            )}
                        </div>

                        {/* Success Modal */}
                        <Modal
                            show={showSuccessModal}
                            onHide={() => setShowSuccessModal(false)}
                            centered
                            backdrop="static"
                        >
                            <Modal.Body className="text-center p-4">
                                <div className="mb-3">
                                    <div
                                        className="rounded-circle d-inline-flex align-items-center justify-content-center border border-success text-success"
                                        style={{ width: 56, height: 56 }}
                                    >
                                        <i className="bi bi-check-lg fs-3"></i>
                                    </div>
                                </div>

                                <h5 className="mb-2 fw-semibold">Deleted successfully</h5>
                                <p className="text-muted mb-4">
                                    The workflow has been removed permanently.
                                </p>

                                <Button
                                    variant="outline-success"
                                    className="px-4"
                                    onClick={() => setShowSuccessModal(false)}
                                >
                                    Done
                                </Button>
                            </Modal.Body>
                        </Modal>

                    </div>
                </div>
            </div>
        </div>
    );
}
